var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [(_vm.$route.meta.layout === 'sign') ? _c('sign-layout', [_c('router-view')], 1) : _c('home-layout', [_c('router-view')], 1), _vm._v(" "), _c('modal-user-agreement'), _vm._v(" "), _c('notification')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610c8a80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1220
// module chunks = 0